export default {
  SEX: 1, // 性别
  STATUS: 2, // 状态
};
